import React, { useCallback } from 'react';
import { SiteStyle } from '../common/SiteStyle';
import { Reporting } from '../common/Reporting';
import { Spacer } from '../common/Spacer';
import { ActionButton } from '../common/ActionButton';
import { Logo } from '../common/Logo';
import { useHistory, useParams } from 'react-router';
import { Token } from '../../model/Model';
import { resetCache } from '../../service/rest';
import { useReportState } from '../../state/state';

export const ResetCache = () => {
    const { token } = useParams<Token>();
    const history = useHistory();
    const {reportError, reportSuccess} = useReportState()

    const resetCacheCallback = useCallback(() => {
        if (token) {
            resetCache(token)
            .then(result => {
                if (result?.success) {
                    reportSuccess("Cache was reset at: " + new Date().toISOString());
                    history.replace(`/welcome/${token}`);
                } else {
                    reportError("No no! a communication error occurred, please try again later.")
                }
            })
            .catch(() => {
                reportError("No no! a communication error occurred, please try again later.")
            });
        }
    }, [token]);

    return (
            <div>
                <SiteStyle />
                <Reporting/>
                <Spacer height="4rem"/>
                <ActionButton text="Reset Cache" onClick={resetCacheCallback}/>
                <ActionButton invert={true} text="Return to Welcome" onClick={() => history.replace(`/welcome/${token}`)}/>
                <Spacer height="6rem"/>
                <Logo/>
            </div>
    )
}
